/**
 * Convert a camelCase (or PascalCase) string to snake_case.
 *
 * @param value - The string to convert
 * @returns snake_case version of the string
 *
 * @example
 * toSnakeCase('organizationId') // 'organization_id'
 * toSnakeCase('totalDurationSeconds') // 'total_duration_seconds'
 */
export function toSnakeCase(value: string): string {
  return value.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}
